import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

(window as any).Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'reverb',
  key: process.env.REACT_APP_REVERB_APP_KEY || '5nfxhd9zeynqmxkkke30',
  wsHost: process.env.REACT_APP_REVERB_HOST || 'localhost',
  wsPort: parseInt(process.env.REACT_APP_REVERB_PORT || '8080'),
  wssPort: parseInt(process.env.REACT_APP_REVERB_PORT || '8080'),
  forceTLS: false,
  enabledTransports: ['ws'],
  disableStats: true,
});

export default echo;
